<template>
  <div class="whitespace-no-wrap">
    <i class="icon-chip"></i>
    System
  </div>
</template>

<script>
export default {
  name: 'SystemUser',
}
</script>
